import type { ReactNode } from "react";

import { cn } from "@/utils/cn";

// Figma: https://www.figma.com/design/HJIp5P6tyeFrUd7ODqeWdM/-PROD--Fertility-V?node-id=3506-5833

export const AVATAR_VARIANTS = ["person", "action"] as const;

export type AvatarVariant = (typeof AVATAR_VARIANTS)[number];

type AvatarProps = {
  /** Initials for a person, or an icon for an action row ("Add New Provider"). */
  children: ReactNode;
  variant?: AvatarVariant;
  /** Layout only. A repeated look is a variant. */
  className?: string;
};

// The 40px frame has no Figma variable (EVY-436).
const BASE = cn(
  "inline-flex size-[40px] flex-none items-center justify-center rounded-ds-corner-full",
  "text-ds-body-base-regular text-ds-ui-elements-black md:text-ds-body-base-regular-desktop"
);

const VARIANTS: Record<AvatarVariant, string> = {
  person: "bg-ds-all-colors-sky",
  action: "bg-ds-background-dark-creme",
};

// Display component, no ref forwarded. See ui/README.md.
export const Avatar = ({
  children,
  variant = "person",
  className,
}: AvatarProps) => {
  return (
    <span className={cn(BASE, VARIANTS[variant], className)}>{children}</span>
  );
};
